module.exports = __webpack_public_path__ + "static/media/SentinelSSm-Bold.03c41fd3.otf";